import { useEffect, useMemo, useState } from "react";
import { Volume2 } from "lucide-react";
import vocabData from "../data/vocabulary.json";
import Card from "./atoms/Card";
import Chip from "./atoms/Chip";

function getDayOfYear(d = new Date()) {
  const start = new Date(d.getFullYear(), 0, 0);
  const diff = d - start;
  return Math.floor(diff / (1000 * 60 * 60 * 24));
}

const allWords = [];
vocabData.forEach((cat) => cat.words.forEach((w) => allWords.push({ ...w, category: cat.category })));

function speak(text) {
  if (!("speechSynthesis" in window)) return;
  window.speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(text);
  u.lang = "en-US";
  u.rate = 0.85;
  window.speechSynthesis.speak(u);
}

export default function WordOfDay({ className = "" }) {
  const word = useMemo(() => {
    const dayIdx = getDayOfYear();
    return allWords[dayIdx % allWords.length];
  }, []);

  // eslint-disable-next-line no-unused-vars
  const [autoSpoken, setAutoSpoken] = useState(false);
  useEffect(() => {
    const lastDate = localStorage.getItem("wordOfDayHeard");
    const today = new Date().toDateString();
    if (lastDate !== today) {
      const t = setTimeout(() => {
        speak(word.word);
        localStorage.setItem("wordOfDayHeard", today);
        setAutoSpoken(true);
      }, 1200);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!word) return null;

  return (
    <Card paperDeep spineColor="var(--gold-500)" className={className} style={{ paddingTop: 28 }}>
      <span className="eyebrow">Word of the day</span>
      {word.category && <Chip tone="neutral" style={{ marginLeft: 8 }}>{word.category}</Chip>}
      <h3 className="font-display" style={{ fontSize: 36, fontWeight: 400, lineHeight: 1.05, margin: "8px 0 4px", display: "flex", alignItems: "center", gap: 12 }}>
        {word.word}
        <button
          type="button"
          onClick={() => speak(word.word)}
          aria-label="Listen"
          style={{ background: "transparent", border: "1px solid var(--border-2)", borderRadius: 999, width: 32, height: 32, display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "var(--ink-700)" }}
        >
          <Volume2 size={14} strokeWidth={1.6} />
        </button>
      </h3>
      <p style={{ color: "var(--fg-2)", fontSize: 15, margin: "0 0 14px", lineHeight: 1.55 }}>{word.meaning}</p>
      {word.example && (
        <button
          type="button"
          onClick={() => speak(word.example)}
          style={{ display: "block", width: "100%", textAlign: "left", background: "transparent", border: 0, borderLeft: "2px solid var(--gold-300)", padding: "0 0 0 12px", color: "var(--fg-2)", fontSize: 14, lineHeight: 1.5, fontStyle: "italic", fontFamily: "var(--font-display)", cursor: "pointer" }}
        >
          "{word.example}"
        </button>
      )}
    </Card>
  );
}
